export const getReceivedResaleMenuOptions = ({
  agreementId,
  baseUrl,
  externalBaseURL,
  cloud,
  accountId,
}: {
  agreementId: string
  baseUrl: string
  externalBaseURL?: string
  cloud?: string
  accountId?: string
}) => {
  let viewUrlPathName: string
  if (externalBaseURL) {
    viewUrlPathName = `${baseUrl}/resale-authorizations/received/${agreementId}/details`
  } else if (cloud && accountId) {
    viewUrlPathName = `/flyout/${cloud}/${accountId}/resale-authorizations/received/${agreementId}/details`
  } else {
    viewUrlPathName = `/flyout/resale-authorizations/received/${agreementId}/details`
  }
  return [
    {
      key: 'view-details',
      label: 'View details',
      disable: false,
      disabledTooltip: '',
      route: viewUrlPathName,
    },
  ]
}

export const getChannelOfferEditPath = ({
  externalBaseURL,
  cloud,
  accountId,
  authorizationId,
}: {
  externalBaseURL?: string
  cloud?: string
  accountId?: string
  authorizationId: string
}) => {
  if (externalBaseURL) {
    return `/flyout/authorization/${authorizationId}/channel-offers/edit`
  }
  if (cloud && accountId) {
    return `/flyout/${cloud}/${accountId}/authorization/${authorizationId}/channel-offers/edit`
  }
  return `/flyout/authorization/${authorizationId}/channel-offers/edit`
}
